import React from "react";
import classNames from "classnames";
import { useFormContext } from "react-hook-form";
import { useRegistrationStore } from "@state/context/membership/registration-types/RegistrationStoreContext";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";

export default observer(function RegistrationTabs(props: {
	hasOnboardingStyling?: boolean;
}) {
	const { trigger } = useFormContext();

	const { isIpRestricted } = useRootAppStore();

	const { currentStep, setCurrentStep, toggleStepSwitchFlag } =
		useRegistrationStore();

	const wrapperClasses = classNames({
		"card--onboarding__steps": !props.hasOnboardingStyling,
		"card--membership__steps": props.hasOnboardingStyling,
	});

	const stepOneClasses = classNames(
		"counter counter--rounded counter--rounded--base counter--dark",
		{
			"u-type--wgt--bold": props.hasOnboardingStyling,
		}
	);

	const stepTwoClasses = classNames(
		"counter counter--rounded counter--rounded--base",
		{
			"counter--medium": currentStep === 1,
			"counter--dark": currentStep === 2,
			"u-type--wgt--bold": props.hasOnboardingStyling,
		}
	);

	return (
		<ErrorBoundaryWithPropagation
			componentName={"Mobile/side-widget/RegistrationTabs.tsx"}
		>
			<div className="section--membership__steps">
				<div
					className={stepOneClasses}
					onClick={() => setCurrentStep(1)}
				>
					{currentStep === 1 ? (
						<>1</>
					) : (
						<i className="u-icon u-icon--tny u-icon--check u-color--core--snow" />
					)}
				</div>
				<button
					type="button"
					className={stepTwoClasses}
					disabled={currentStep === 2 || isIpRestricted}
					onClick={async () => {
						toggleStepSwitchFlag(true);
						const isValid = await trigger();

						if (isValid) {
							setCurrentStep(2, true);
						}
						toggleStepSwitchFlag(false);
					}}
				>
					2
				</button>
			</div>
		</ErrorBoundaryWithPropagation>
	);
});
